import React from "react";
import { Form, Button } from "react-bootstrap";
import Message from "../../../components/message";
import {
  MediumButtonStyle,
  SmallButtonStyle,
} from "../../../components/ButtonStyle";
import { BackgroundGradientStyle } from "../../../components/BackgoundGradient";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";

export default class LogisticsReg2 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      MaterialMovRoute: "",
      Full_Load_Freight_Rate: "",
      Small_Package_Freight_Rate: "",
      MaterialMovFreq: "",
      DeliverInsured: "",
      RouteMap: "",
    };
  }

  isdeliverylist = [{ title: "Yes" }, { title: "No" }];

  flatProps = {
    options: this.isdeliverylist.map((option) => option.title),
  };

  defaultProps1 = {
    options: this.isdeliverylist,
    getOptionLabel: (option) => option.title,
  };


  saveandContinue = async (e) => {
    await this.props.uploadData();
    this.props.nextStep();
  };

  render() {
    const {
      error,
    } = this.state;
    return (
      <div id="root">
        <div style={BackgroundGradientStyle}>
          <div style={{ fontSize: 12 }}>
            {error && <Message variant="danger">{error}</Message>}
          </div>
          {/* {loading && <Loader/>} */}

          <div
            id="root"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div
              style={{
                width: "100%",
                padding: 0,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div
                style={{ padding: "20px 10px", margin: "20px 20px 20px 20px" }}
              >
                <div
                  style={{
                    backgroundColor: "white",
                    width: 360,
                    height: 550,
                    padding: "10px 25px",
                  }}
                >
                  <strong
                    style={{
                      color: "black",
                      fontSize: 24,
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "left",
                      justifyContent: "left",
                    }}
                  >
                    Create Account
                  </strong>
                  {/* <Form onSubmit={submitHandler}> */}
                  <Form.Label
                    style={{
                      marginTop: 5,
                      fontSize: 13,
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "left",
                      justifyContent: "left",
                      color: "black",
                    }}
                  >
                    Fill the form to create a new logistics account.
                  </Form.Label>

                  <Form.Group
                    controlId="MaterialMovRoute"
                    style={{
                      borderRadius: 0,
                      marginTop: 20,
                      border: 0,
                      borderBottom: "1px solid #5DA7CA",
                      display: "flex",
                      direction: "row",
                    }}
                  >
                    <Form.Control
                      style={{
                        width: 750,
                        borderRadius: 0,
                        fontSize: 15,
                        boxShadow: "none",
                        paddingLeft: 0,
                        border: 0,
                      }}
                      type="text"
                      placeholder="Material Movement Route/Transport Route"
                      defaultValue={this.props.values.MaterialMovRoute}
                      onChange={(e) =>
                        this.props.handleChange(
                          "MaterialMovRoute",
                          e.target.value
                        )
                      }
                    ></Form.Control>
                  </Form.Group>

                  <Form.Group
                    controlId="Full_Load_Freight_Rate"
                    style={{
                      borderRadius: 0,
                      marginTop: 20,
                      border: 0,
                      borderBottom: "1px solid #5DA7CA",
                      display: "flex",
                      direction: "row",
                    }}
                  >
                    <Form.Control
                      style={{
                        width: 750,
                        borderRadius: 0,
                        fontSize: 15,
                        boxShadow: "none",
                        paddingLeft: 0,
                        border: 0,
                      }}
                      type="numeric"
                      placeholder="Freight Rate for Full Loading"
                      defaultValue={this.props.values.Full_Load_Freight_Rate}
                      onChange={(e) =>
                        this.props.handleChange(
                          "Full_Load_Freight_Rate",
                          e.target.value
                        )
                      }
                    ></Form.Control>
                  </Form.Group>

                  <Form.Group
                    controlId="Small_Package_Freight_Rate"
                    style={{
                      borderRadius: 0,
                      marginTop: 20,
                      border: 0,
                      borderBottom: "1px solid #5DA7CA",
                      display: "flex",
                      direction: "row",
                    }}
                  >
                    <Form.Control
                      style={{
                        width: 750,
                        borderRadius: 0,
                        fontSize: 15,
                        boxShadow: "none",
                        paddingLeft: 0,
                        border: 0,
                      }}
                      type="numeric"
                      placeholder="Freight Rate for Small Packages/ Cartoon"
                      defaultValue={
                        this.props.values.Small_Package_Freight_Rate
                      }
                      onChange={(e) =>
                        this.props.handleChange(
                          "Small_Package_Freight_Rate",
                          e.target.value
                        )
                      }
                    ></Form.Control>
                  </Form.Group>

                  <Form.Group
                    controlId="MaterialMovFreq"
                    style={{
                      borderRadius: 0,
                      marginTop: 20,
                      border: 0,
                      borderBottom: "1px solid #5DA7CA",
                      display: "flex",
                      direction: "row",
                    }}
                  >
                    <Form.Control
                      style={{
                        width: 750,
                        borderRadius: 0,
                        fontSize: 15,
                        boxShadow: "none",
                        paddingLeft: 0,
                        border: 0,
                      }}
                      type="numeric"
                      placeholder="Frequency of Material Movement in route"
                      defaultValue={this.props.values.MaterialMovFreq}
                      onChange={(e) =>
                        this.props.handleChange(
                          "MaterialMovFreq",
                          e.target.value
                        )
                      }
                    ></Form.Control>
                  </Form.Group>

                  <Autocomplete
                    style={{ marginTop: -20, marginBottom: -5 }}
                    {...this.defaultProps1}
                    defaultValue={this.props.values.DeliverInsured}
                    id="DeliverInsured"
                    onInputChange={(e, v) =>
                      this.props.handleChange("DeliverInsured", v)
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Is Delivery Insured"
                        margin="normal"
                      />
                    )}
                  />

                  <Form.Group
                    controlId="RouteMap"
                    style={{
                      borderRadius: 0,
                      marginTop: 20,
                      border: 0,
                      borderBottom: "1px solid #5DA7CA",
                      display: "flex",
                      direction: "row",
                    }}
                  >
                    <Form.Control
                      style={{
                        width: 750,
                        borderRadius: 0,
                        fontSize: 15,
                        boxShadow: "none",
                        paddingLeft: 0,
                        border: 0,
                      }}
                      type="text"
                      placeholder="Route Map"
                      defaultValue={this.props.values.RouteMap}
                      onChange={(e) =>
                        this.props.handleChange("RouteMap", e.target.value)
                      }
                    ></Form.Control>
                  </Form.Group>

                  <div
                    style={{
                      marginTop: 25,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      flexDirection: "column",
                    }}
                  >
                    <Button
                      onClick={this.saveandContinue}
                      type="submit"
                      style={MediumButtonStyle}
                    >
                      Save & Continue{" "}
                      <i style={{ marginLeft: 5 }} className="fas fa-angle-right" />
                    </Button>
                    <div style={{ marginTop: 10 }}></div>
                    <Button
                      type="submit"
                      onClick={this.props.prevStep}
                      style={SmallButtonStyle}
                    >
                      Back
                      <i style={{ marginLeft: 5 }} className="fas fa-angle-left" />
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
